function setResultMetrics(row, resultIndicator) {
  row.cells.resultIndicator = resultIndicator;
  row.cells.results = row.cells.results?.[row.cells.resultIndicator] ?? row.cells[row.cells.resultIndicator];
  row.cells.cvr = row.cells.cvr?.[row.cells.resultIndicator];
  row.cells.cpr = row.cells.cpr?.[row.cells.resultIndicator];
  if (!row.cells.cvr && row.cells.impressions) {
    row.cells.cvr = row.cells.results / row.cells.impressions;
  }
  if (!row.cells.cpr && row.cells.results) {
    row.cells.cpr = row.cells.spend / row.cells.results;
  }
  delete row.cells.resultIndicators;
}

function getResultMetricFieldValue(field, resultIndicator, row) {
  const results = row.cells.results?.[resultIndicator] ?? row.cells[resultIndicator];
  if (field === 'result') {
    return results;
  } else if (field === 'cvr') {
    let cvr = row.cells.cvr?.[resultIndicator];
    if (!cvr && row.cells.impressions) {
      cvr = results / row.cells.impressions;
    }
    return cvr;
  } else if (field === 'cpr') {
    let cpr = row.cells.cpr?.[resultIndicator];
    if (!cpr && results) {
      cpr = row.cells.spend / results;
    }
    return cpr;
  }
}

function getResultIndicator(rows) {
  let resultIndicator = 'clicks';
  const resultIndicatorSet = new Set();
  for (const row of rows) {
    if (!row.cells) {
      continue;
    }
    if (resultIndicatorSet.size > 1) {
      break;
    }
    if (row.cells.resultIndicators?.length) {
      for (const indicator of row.cells.resultIndicators) {
        resultIndicatorSet.add(indicator);
      }
    }
  }
  if (resultIndicatorSet.size === 1) {
    [resultIndicator] = resultIndicatorSet;
  }
  return resultIndicator;
}

module.exports = {
  getResultIndicator,
  getResultMetricFieldValue,
  setResultMetrics,
};
